<template>
  <div class="container-flex fill-flex-full">
    <div v-if="reloading" id="circle2"></div>
    <global-error v-if="globalError" />
    <div v-else class="container-right container-flex fill-flex-full">
      <div class="container-flex fill-flex-full">
        <div
          class="main container-flex fill-flex-full"
          v-if="client && client.billing && client.clientGroup"
        >
          <div class="container-fluid container-flex fill-flex-full bg-white">
            <div class="spacer-75"></div>

            <div class="spacer-40"></div>
            <!--<div class="container-wide container-flex fill-flex-full">
              <div class="spacer-75"></div>

              <div class="spacer-40"></div>
              <div class="row px-dynamic">
                <div class="col-12 col-md-8">
                  <div class="h1-rem digit-font">
                    <span class="active-o">
                      {{ client.billing.balance }}&nbsp;₽ </span
                    ><span class="font-rem-15">на счете</span>
                  </div>
                  <p>
                    <span>
                      {{ capitalize(client.billing.activeName) }}
                    </span>
                  </p>
                  <div>
                    <p>Списано в текущем периоде 14504,33&nbsp;₽</p>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <a href="#" type="button" class="my-3 btn btn-blue"
                    >Пополнить баланс</a
                  >
                </div>
                <div class="col-12">
                  <div class="spacer-40"></div>
                  <div class="spacer-40 border-t-full"></div>
                </div>
              </div>
            </div>-->

            <div
              class="container-wide container-flex fill-flex-full"
              v-for="objClient in client.clientGroup"
              :key="objClient.clientId"
            >
              <div class="row px-dynamic">
                <div v-if="client" class="col h1-rem">
                  {{ objClient.clientName }}
                </div>
              </div>

              <div class="row px-dynamic">
                <div class="col-md-6">
                  <div class="col-12 py-2" v-if="objClient.clientId">
                    <span class="grey pr-3 d-inline-block"
                      >Номер лицевого счета
                    </span>
                    <span class="pr-3 d-inline-block">{{
                      objClient.clientId
                    }}</span>
                  </div>

                  <div class="col-12" v-if="objClient.contracts.length > 0">
                    <!--<div class="col-12">
                      <span class="grey pr-3 py-2 d-inline-block"
                        >На текущую дату на счете:
                      </span>
                      <span
                        :class="objClient.contracts[0].balance < 0 ? 'red' : ''"
                        class="pr-3 py-2 d-inline-block"
                        >{{
                          objClient.contracts[0].balance === null ||
                          objClient.contracts[0].balance === undefined
                            ? 0
                            : objClient.contracts[0].balance
                        }}&nbsp;₽</span
                      >
                    </div>-->
                    <div class="col-12 py-2 d-flex align-items-center">
                      <span class="grey pr-3 d-inline-block"
                        >Остаток на {{ currentMonth.date }}
                      </span>
                      <span
                        :class="
                          objClient.contracts[0].balanceMonthStart < 0
                            ? 'red'
                            : ''
                        "
                        class="pr-3 d-inline-block font-weight-bold amount"
                        >{{
                          objClient.contracts[0].balanceMonthStart ?? 0
                        }}&nbsp;₽</span
                      >
                    </div>
                    <div class="col-12 py-2 d-flex align-items-center">
                      <span class="grey pr-3 d-inline-block"
                        >Задолженность за предыдущие месяцы</span
                      >
                      <span
                        class="pr-3 d-inline-block"
                        :class="
                          objClient.contracts[0].balanceMonthStart < 0
                            ? 'font-weight-bold amount'
                            : ''
                        "
                      >
                        {{
                          objClient.contracts[0].balanceMonthStart >= 0
                            ? "отсутствует"
                            : -objClient.contracts[0].balanceMonthStart +
                              "&nbsp;₽"
                        }}
                      </span>
                      <!-- <span
                        class="pr-3 py-2 d-inline-block"
                        v-if="objClient.contracts[0].balanceMonthStart < 0"
                        >{{
                          -1 * objClient.contracts[0].balanceMonthStart
                        }}&nbsp;₽</span
                      > -->
                    </div>
                    <div class="col-12 align-items-center py-2 d-flex">
                      <span class="grey pr-3 d-inline-block"
                        >Рекомендовано оплатить в {{ currentMonth.month }}
                      </span>
                      <span class="pr-3 d-inline-block font-weight-bold amount"
                        >{{
                          objClient.contracts[0]
                            .recommendedPaymentSumThisMonth ?? 0
                        }}&nbsp;₽</span
                      >
                    </div>
                    <div
                      class="col-12 py-2 align-items-center d-flex"
                      v-if="remainingPayment > 0"
                    >
                      <span class="grey pr-3 d-inline-block"
                        >Осталось доплатить
                      </span>
                      <span
                        class="pr-3 d-inline-block font-weight-bold amount"
                        :class="remainingPayment > 0 ? 'red' : ''"
                        >{{ remainingPayment.toFixed(2) }}&nbsp;₽</span
                      >
                    </div>
                    <div class="col-12 col-md-4">
                      <router-link
                        v-if="objClient.clientId"
                        :to="{
                          name: 'payment',
                          params: {
                            client: objClient.clientName,
                          },
                          query: {
                            contract: encodeURIComponent(
                              objClient.contracts[0].contractNumber ||
                                objClient.contracts[0].number,
                            ),
                            clnum: objClient.clientId,
                          },
                        }"
                        class="my-3 btn btn-blue"
                      >
                        Пополнить баланс
                      </router-link>
                    </div>
                    <div class="col-12">
                      {{
                        objClient.payments
                          ? "Платежи в текущем месяце:"
                          : "Платежей в текущем месяце нет"
                      }}
                    </div>
                    <div
                      v-for="(payment, index) in objClient.payments"
                      :key="index"
                      class="col-6 d-flex justify-content-between"
                    >
                      <div>{{ payment.date }}</div>
                      <div>{{ payment.sum.toFixed(2) }}&nbsp;₽</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" style="margin-top: 0">
                  <div class="col-12" v-if="objClient.contracts.length > 0">
                    <span class="grey pr-3 py-2 d-inline-block"
                      >Номер договора
                    </span>
                    <span class="pr-3 py-2 d-inline-block">{{
                      objClient.contracts[0].contractNumber ||
                      objClient.contracts[0].number
                    }}</span>
                  </div>
                  <div class="col-12" v-if="objClient.contracts.length > 0">
                    <span class="grey pr-3 py-2 d-inline-block"
                      >Дата заключения договора
                    </span>
                    <span class="pr-3 py-2 d-inline-block">{{
                      formatDate(objClient.contracts[0].date)
                    }}</span>
                  </div>
                  <div class="col-12" v-if="objClient.inn && objClient.kpp">
                    <span class="grey pr-3 py-2 d-inline-block">ИНН/КПП </span>
                    <span class="pr-3 py-2 d-inline-block"
                      >{{ objClient.inn }}/{{ objClient.kpp }}</span
                    >
                  </div>
                  <!-- <div class="col-12" v-if="objClient.kpp">
                  <span class="grey pr-3 py-2 d-inline-block">КПП </span>
                  <span class="pr-3 py-2 d-inline-block">{{
                    objClient.kpp
                  }}</span>
                </div> -->
                  <div class="col-12" v-if="objClient.email">
                    <span class="grey pr-3 py-2 d-inline-block">E-mail</span>
                    <span class="pr-3 py-2 d-inline-block">{{
                      objClient.email
                    }}</span>
                  </div>
                  <div class="col-12" v-if="objClient.phone">
                    <span class="grey pr-3 py-2 d-inline-block"
                      >Контактный телефон
                    </span>
                    <span class="pr-3 py-2 d-inline-block">{{
                      objClient.phone
                    }}</span>
                  </div>
                </div>

                <!--<div class="col-12 d-flex flex-wrap">
                  <div class="grey pr-3 py-2 my-auto">Контактный телефон</div>
                  <inline-value-editor
                    ref="phoneInlineEditor"
                    :value="objClient.phone"
                    type="tel"
                    emptyValue="не указан"
                    inputMask="['+7 (###) ##-##-##', '+7 (###) ###-##-##']"
                    checkMask="^\D*[78](\D*\d\D*){10}$"
                    saveProfileProperty="phoneNumber"
                    saveOkClientProperty="phoneNumber"
                    @startEditing="$refs.emailInlineEditor.cancel()"
                  />
                </div>
                <div class="col-12 d-flex flex-wrap">
                  <div class="grey pr-3 py-2 my-auto">E-mail</div>
                  <inline-value-editor
                    ref="emailInlineEditor"
                    :value="objClient.email"
                    emptyValue="не указан"
                    :checkMask="config.regexp.email"
                    saveProfileProperty="email"
                    saveOkClientProperty="email"
                    @startEditing="$refs.phoneInlineEditor.cancel()"
                  />
                </div>-->
                <div class="spacer-75"></div>

                <div class="spacer-40"></div>
              </div>
            </div>
            <div class="fill-flex-full"></div>
            <div class="spacer-75"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script defer>
import { mapActions, mapGetters, mapState } from "vuex";
import GlobalError from "../components/GlobalError.vue";
//import InlineValueEditor from "./InlineValueEditor.vue";
import config from "../config.js";
import utils from "../utils.js";

export default {
  components: {
    GlobalError,
    //InlineValueEditor,
  },
  data() {
    return {
      reloading: false,
    };
  },
  computed: {
    ...mapState(["payments"]),
    ...mapGetters(["globalError", "client", "remainingPayment"]),

    config() {
      return config;
    },

    currentMonth() {
      const now = new Date();
      return utils.getMonth(now, 1);
    },
  },

  created() {
    // TODO: костыль
    this.fetchClient().then(() => {
      this.fetchGroupCurrentMonthPayments({
        sdate: this.currentMonth.date
          .slice(0, -3)
          .split(".")
          .reverse()
          .join("-"),
      }).then(() => {
        for (const item of this.client.clientGroup) {
          for (const payment of this.payments) {
            if (payment.clientId === item.clientId) {
              if (item.payments === undefined) {
                item.payments = [];
              }
              payment.date = payment.date
                .split(" ")[0]
                .split("-")
                .reverse()
                .join(".");
              item.payments.push(payment);
            }
          }
        }
      });
    });
  },

  methods: {
    ...mapActions(["fetchClient", "fetchGroupCurrentMonthPayments"]),

    capitalize(word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    },

    formatDate(date) {
      return date.split(" ")[0].split("-").reverse().join(".");
    },
  },
};
</script>
